module.exports = __webpack_public_path__ + "img/img1.2b3d93a7.jpg";